
    <div class="Customers customer-company ui-g">
      <div class="ui-g ui-fluid" style="width: 100%">
        <div class="ui-g-12">
          <div>
            <div class="ui-g ui-g-nopad form-group master-data">
              <div class="ui-g-12 ui-lg-8 ui-g-nopad">
                <h1 class="step-title">{{ titlePage | translate}}</h1>
              </div>
              <div class="ui-g-12 ui-lg-4 text-right">
                <button *ngIf="!shortInsert" pButton type="button" class="k-generic-btn" icon="fa fa-angle-left" iconPos="left" label="Back"
                        (click)="locationBack()"></button>
              </div>
              <form class="ui-g-12" (ngSubmit)="selectWizard(wizardForm.controls['wizard_id'].value)"
                    [formGroup]="wizardForm">
                <div class="ui-g form-group master-data">
                  <div [kv-form-element]="{ label: 'promotion.wizard', md: '8' }">
                    <p-dropdown [disabled]="tab === true" formControlName="wizard_id" [options]="wizards"
                                [filter]="true" [style]="{'width':'100%' }"></p-dropdown>
                  </div>
                  <div style="padding-top: 40px; padding-left: 60px;" class="ui-g-4">
                    <button *ngIf="!shortInsert" [disabled]="editMessage !== null || !dis" type="submit" icon="fa fa-check-circle" pButton class="k-generic-btn" label="Ok"></button>
                    <button *ngIf="shortInsert" [disabled]="this.wizardForm.controls['wizard_id'].value === null || dis2" (click)="dis2 = true; selectWizard(wizardForm.controls['wizard_id'].value)" type="button" icon="fa fa-check-circle" pButton class="k-generic-btn" label="Ok"></button>
                  </div>
                </div>
              </form>
              <div *ngIf="tab" class="ui-g-12 ui-lg-12 ui-g-nopad customers-steps">
                <p-steps [style]="{'width': '100%'}" [model]="items" [(activeIndex)]="activeTabIndex"
                         [readonly]="false"></p-steps>
              </div>
            </div>
          </div>
          <div *ngIf="tab" class="ui-g-12">
            <div class="card" [hidden]="this.activeTabIndex !== activeTab.message">
              <app-tab-message
                [hidden]="this.activeTabIndex !== activeTab.message"
                [messageConfigs]="messageConfigs"
                [discountTypes]="discountTypes"
                [selectedWizard]="selectedWizardId"
                [wizards]="wizards"
                [messagesTypes]="messagesTypes"
                [barCodes]="barCodes"
                [clusters]="clusters"
                [templates]="templates"
                (saveMessage)="saveMessageType($event)"
                [editMessage]="editMessage"
                [shortInsert]="shortInsert"
                (saveMessageAndBack)="saveMessageType($event, true)"
                *ngIf="tab">
              </app-tab-message>
            </div>
            <div class="card" [hidden]="this.activeTabIndex !== activeTab.layout">
              <app-tab-layout
                [editMessage]="editMessage"
                [touchPoints]="touchPoints"
                [layouts]="layouts"
                *ngIf="editMessage">
              </app-tab-layout>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  


// WEBPACK FOOTER //
// ./src/app/views/promotion/message/components/messageDetail.component.ts.MessageDetailComponent.html